import React from "react";
import "./Clients.css";
import img1 from '../Images/img1.jpg'
import img2 from '../Images/img2.jpg'
import img3 from '../Images/img3.jpg'
import img4 from '../Images/img4.jpg'
import img5 from '../Images/img5.png'
import img6 from '../Images/img6.png'
import img7 from '../Images/img7.jpg'
import img8 from '../Images/img8.png'
import img9 from '../Images/img9.jpg'
import img10 from '../Images/img10.png'
import img11 from '../Images/img11.png'
import img12 from '../Images/img12.jpg'
import img13 from '../Images/img13.png'
import img14 from '../Images/img14.jpg'
import img15 from '../Images/img15.jpg'
import img16 from '../Images/img16.jpg'
import img17 from '../Images/img17.jpg'
import img18 from '../Images/img18.jpg'
import img19 from '../Images/img19.jpg'
import img20 from '../Images/img20.jpg'
import img21 from '../Images/img21.jpg'
import img22 from '../Images/img22.png'
import img23 from '../Images/img23.png'
import img24 from '../Images/img24.jpg'
import rge from '../Images/rge.png'
import omaxe from '../Images/omaxe.jpg'
import vipul from '../Images/vipul.jpg'
import street from '../Images/highstreet.jpg'
import capital from '../Images/capital.png'
import genesis from '../Images/genesis.jpg'
import idea from '../Images/idea.png'
import inox from '../Images/inox.jpeg'
import srs from '../Images/srs.jpg'
import pvr from '../Images/pvr.jpg'
import vsq from '../Images/vsq.png'
import alka from '../Images/alka.jpg'
import ael from '../Images/ael.jpg'
import asia from '../Images/asia.gif'
import auro from '../Images/auro.jpg'
import bjain from '../Images/bjain.jpg'
import bry from '../Images/lab_BryAir.jpg'
import eal from '../Images/eal.png'
import ichi from '../Images/ichi.jpg'
import lb from '../Images/lb.jpg'
import honda from '../Images/honda.jpg'
import yutaka from '../Images/yutaka.jpg'
import bestex from '../Images/bestex.jpg'
import ushin from '../Images/ushine.jpg'
import pepsi from '../Images/pepsi.jpeg'
import pi from '../Images/pi.png'
import rayban from '../Images/rayban.png'
import roca from '../Images/roca.png'
import accil from '../Images/accil.jpg'
import alpha from '../Images/alpha.png'
import amtek from '../Images/amtek.jpg'
import badve from '../Images/badve.jpg'
import aov from '../Images/aov.png'
import ice from '../Images/iceboy.png'
import dri from '../Images/dri.png'
import ccp from '../Images/ccp.jpg'
import czone from '../Images/czone.jpg'
import et from '../Images/et.jpg'
import elanpro from '../Images/elanpro.jpg'
import fackle from '../Images/fackle.png'
import giga from '../Images/giga.jpg'
import greenauto from '../Images/greenauto.jpg'
import hs from '../Images/hs.png'
import ist from '../Images/ist.jpg'
import kei from '../Images/kei.jpg'
import mm from '../Images/mm.png'
import coils from '../Images/coils.png'
import mfe from '../Images/mfe.gif'
import oc from '../Images/oc.jpg'
import pm from '../Images/pm.png'
import scci from '../Images/scci.png'
import sw from '../Images/sw.png'
import sigma from '../Images/sigma.jpg'
import skipper from '../Images/skipper.jpg'
import usg from '../Images/usg.jpg'
import db from '../Images/db.png'
import om from '../Images/om.png'
import auto_mm from '../Images/auto_mm.png'
import auto_mfe from '../Images/auto_mfe.png'
import inter from '../Images/interface.png'
import goi from '../Images/goi.png'
import dlf from '../Images/dlf.png'
import hli from '../Images/hli.png'
import indis from '../Images/indis.png'
import gtekt from '../Images/gtekt.jpg'


export default function Clients() {
  return (
    <div id="social-section">
      <div class="container">
        <h2>
         <strong>Our Satisfactory Clients</strong>
        </h2>

        <div class="row ">
        <div class="row-lg-1 row-md-1 row-sm-1">
            <strong>Automotive &amp; Engineering</strong>
          </div>

          <div class="col-lg-11 col-md-11 col-sm-11">
            <marquee direction="left">
            <img src={ushin}/>
              <img src={auto_mm} />
              <img src={auto_mfe} />
              <img src={inter} />
              <img src={indis}/>
              <img src={goi} />
              <img src={hli}/>
            </marquee>
          </div>

          <div class="row-lg-1 row-md-1 row-sm-1">
            <strong>Hotel Industry</strong>
          </div>
          <div class="col-lg-11 col-md-11 col-sm-11">
            <marquee direction="left">
              <img src={img1}/>
              <img src={img2}/>
              <img src={img3} />
              <img src={img4}/>
              {/* <img src={img5} /> */}
              <img src={img6} />
              <img src={img7} />
              <img src={img8} />
              <img src={img9}/>
              <img src={img10}/>
              <img src={img11}/>
              <img src={img12} />
              <img src={img13}/>
              <img src={img14} />
              <img src={img15}/>
              <img src={img16} />
              <img src={img17} />
              <img src={img18}/>
              <img src={img19}/>
            </marquee>
          </div>

          <div class="row-lg-1 row-md-1 row-sm-1">
            <strong>Builders &amp; Commercial</strong>
          </div>

          <div class="col-lg-11 col-md-11 col-sm-11">
            <marquee direction="left">
              <img src={dlf} style={{filter: "invert(100%)" , backgroundColor:'tint(white, 100%)'}} />
              <img src={img20} />
              <img src={img21} />
              <img src={img22} style={{filter: "invert(100%)" , backgroundColor:'tint(white, 100%)'}}/>
              <img src={img23} />
              <img src={img24} style={{filter: "invert(100%)" , backgroundColor:'tint(white, 100%)'}}/>
              <img src={rge} />
              <img src={street} />
              <img src={omaxe}/>
              <img src={vipul}/>
              <img src={capital} />
              <img src={genesis}/>
              <img src={idea}/>
              <img src={inox}/>
              <img src={pvr}/>
              <img src={srs} />
              <img src={vsq}/>
            </marquee>
          </div>

          <div class="row-lg-1 row-md-1 row-sm-1">
            <strong>Pharmaceutical &amp; Labs</strong>
          </div>
          <div class="col-lg-11 col-md-11 col-sm-11">
            <marquee direction="left">
              <img src={alka} />
              <img src={ael}/>
              <img src={asia} />
              <img src={auro} />
              <img src={bjain}/>
              <img src={bry} />
              <img src={eal} />
              <img src={ichi}/>
              <img src={lb}/>
            </marquee>
          </div>

          <div class="row-lg-1 row-md-1 row-sm-1">
            <strong>Industries, Logistics &amp; Warehouse</strong>
          </div>
          <div class="col-lg-11 col-md-11 col-sm-11">
            <marquee direction="left">
              <img src={honda} />
              <img src={bestex} />
              <img src={yutaka}/>
              {/* <img src={ushin}/> */}
              <img src={pepsi} />
              <img src={pi} />
              <img src={rayban} />
              <img src={roca}/>
              <img src={accil} />
              <img src={alpha}/>
              <img src={amtek} />
              <img src={badve} />
              <img src={aov} />
              <img src={ice} />
              <img src={dri} />
              <img src={ccp} />
              <img src={czone} />
              <img src={elanpro}/>
              <img src={et} />
              <img src={fackle} style={{filter: "invert(100%)" , backgroundColor:'tint(white, 100%)'}}/>
              <img src={giga} />
              <img src={greenauto} />
              <img src={hs}/>
              <img src={ist} />
              <img src={kei}/>
              {/* <img src={mm} /> */}
              <img src={coils}/>
              {/* <img src={mfe} /> */}
              <img src={oc} />
              <img src={pm}/>
              <img src={scci}/>
              <img src={sw} />
              <img src={sigma}/>
              <img src={skipper}/>
              <img src={usg} />
              <img src={db} />
              <img src={om}/>
              <img src={gtekt}/>
            </marquee>
          </div>
          
        </div>
      </div>
    </div>
  );
}





